import { NumberSymbol } from "@angular/common";

export class Canales {
    id: number
    idEmisor: number
    pesoCompra: number
    pesoProcesado: number
    merma: number
    lote: string
    tipoId: number
    valor: number
}
